module.exports = __webpack_public_path__ + "img/icon-medium.4a256bed.svg";